import { useMutation } from "react-query";
import { updateScorecard } from "../../../../actions/CarrierAgreementMgmt/ScoreCard";

const useEditScoreCard = () => {
    return useMutation(updateScorecard);
};
export default useEditScoreCard;